import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import administracao from './administracao'
import cadastro from './cadastro'
import integracao from './integracao'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    routes: [
        {
            meta: {layout: 'login', title: 'Acesso náo permitido'},
            name: '403',
            path: '/403',
            component: () => import(/* webpackChunkName: '403' */  '@/views/errors/403')
        },
        {
            meta: {layout: 'login', title: 'Página não encontrada'},
            name: '404',
            path: '*',
            component: () => import(/* webpackChunkName: '404' */ '@/views/errors/404')
        },
        {
            meta: {authenticated: true, layout: 'admin', title: 'Dashboard'},
            name: 'dashboard',
            path: '/dashboard',
            component: () => import(/* webpackChunkName: 'dashboard' */ '@/views/Dashboard'),
        },
        {
            meta: {layout: 'login', title: 'Login'},
            name: 'login',
            path: '/login',
            component: () => import(/* webpackChunkName: 'login' */ '@/views/autenticacao/Login'),
        },
        {
            meta: {authenticated: true, layout: 'admin', title: 'Meu perfil'},
            name: 'perfil-edit',
            path: '/perfil/edit',
            component: () => import(/* webpackChunkName: 'perfil' */ '@/views/Perfil'),
        },
        {
            meta: {layout: 'login', title: 'Recuperar senha'},
            name: 'recuperar-senha',
            path: '/recuperar-senha',
            component: () => import(/* webpackChunkName: 'recuperar-senha' */ '@/views/autenticacao/RecuperarSenha'),
        },
        {
            meta: {authenticated: true, layout: 'login', title: 'Trocar senha'},
            name: 'trocar-senha',
            path: '/trocar-senha',
            component: () => import(/* webpackChunkName: 'dashboard' */ '@/views/autenticacao/TrocarSenha'),
        },
        ...administracao,
        ...cadastro,
        ...integracao,
    ],
})

router.beforeEach((to, from, next) => { 
    const usuario = store.state.usuario
    const token = store.state.token

    if (!to.matched.length) {
        return next({name: '404'})
    }

    if (to.name !== 'login') {
        if (to.name !== 'trocar-senha' && usuario && usuario.troca_senha === true) {
            next('/trocar-senha')
        }

        if (to.matched.some(record => record.meta.authenticated)) {
            if (token === null) {
                next('/login')
            }
        }

        if (to.params && to.params.notification !== false) {
            if ((from.path.includes('create') || from.path.includes('edit')) && !to.path.includes('login')) {
                store.dispatch('createNotification', {
                    type: 'dialog',
                    persistent: true,
                    color: 'warning',
                    title: 'Confirmação',
                    message: 'As informações não salvas serão perdidas. Deseja realmente sair?',
                    onConfirm: async () => {
                        next()
                    },
                    onCancel: null,
                    onError: null,
                })
            } else {
                next()
            }
        } else {
            next()
        }
    } else {
        next()
    }
})

router.afterEach((to) => {
    document.title = 'Intranet - ' + to.meta.title
})

export default router